export default __webpack_public_path__ + "static/media/weatherIcon.e1672d6f.svg";